/**
 * Delete a timeline everywhere: this device, then OPBridge on every computer
 * it is on. An offline computer is named in a toast and the delete is retried
 * when it is back (forgetTimelineSync's `unreachable` list).
 *
 * ONE path for every Delete button (2026-10-16). Navigate's Timelines list
 * removed it from this device only, so the copy on each OPBridge stayed
 * behind; the two editors each carried their own copy of this.
 */
import { bridges } from '../opbridge/store.ts';
import { pushToast } from '../ui/toast.ts';
import { forgetTimelineSync } from './autoSync.ts';
import { deleteTimelineEverywhere } from './bridgeSync.ts';
import { getTimeline, removeTimeline } from './store.ts';

export function deleteTimelineFromRig(id: string): void {
  const name = getTimeline(id)?.name ?? 'the timeline';
  removeTimeline(id);
  void deleteTimelineEverywhere(id).then((results) => {
    const unreachable = results
      .filter((r) => r.kind !== 'ok')
      .map((r) => bridges().find((b) => b.id === r.target))
      .filter((b): b is NonNullable<typeof b> => !!b);
    forgetTimelineSync(id, unreachable);
    if (unreachable.length > 0) {
      const names = unreachable.map((b) => b.name || 'a bridge').join(', ');
      pushToast('warn', `Deleted "${name}". ${names} ${unreachable.length === 1 ? 'is' : 'are'} not reachable right now; it will be removed there automatically when it is back.`);
    }
  });
}
